import JsBarcode from 'jsbarcode'
import React, { useEffect, useRef } from 'react'

function Barcode({ value, renderer = 'svg', ...props }) {
  const ref = useRef(null)

  useEffect(() => {
    if (value) new JsBarcode(ref.current, value, props)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  if (renderer === 'svg') {
    return <svg ref={ref} />
  } else if (renderer === 'canvas') {
    return <canvas ref={ref} />
  } else if (renderer === 'img') {
    return <img ref={ref} />
  }
}

export default Barcode
